import {inject, Injectable}                                from '@angular/core';
import {Auth, signInWithEmailAndPassword, signInWithPopup} from '@angular/fire/auth';
import {Router}                                            from '@angular/router';
import {GoogleAuthProvider, User}                          from 'firebase/auth';
import {BehaviorSubject}                                   from 'rxjs';


@Injectable({
				providedIn: 'root'
			})
export class LogrAuthService {

	router = inject(Router)
	auth = inject(Auth)
	public user = new BehaviorSubject<User | null>(
		null
	);
	clinicianEmail: string = '';
	clinicianPword: string = '';


	loginWithGoogle() {
		signInWithPopup(this.auth, new GoogleAuthProvider())
			.then((result) => this.processLoginReturn(result.user))
			.catch((error) => {
				console.error('Error logging in with Google', error);
			});
	}

	signInWithEmailAndPassword() {
		signInWithEmailAndPassword(
			this.auth,
			this.clinicianEmail,
			this.clinicianPword
		)
			.then((result) => this.processLoginReturn(result.user))
			.catch((error) => {
				console.error('Error logging in with Google', error);
			});
	}

	processLoginReturn(user: User) {
		this.user.next(user)
		this.router.navigate(['/'])
		// this.svcDataFetch
		// 	.checkOrCreateUserRecord(user.providerData[0], user.uid)
		// 	.then((userRecord) => {
		// 		this.user.next(user);
		// 		// this.router.navigate([ '/' ]);
		// 	})
		// 	.catch((error) => {
		// 		console.error('Error processing user record', error);
		// 	});
	}
}
